import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import {
    cadastrarUsuariosEmpresaEmLote,
    limparRetornocadastramentoUsuariosEmpresaEmLote,
} from '../../../actions/usuario/cadastrarUsuariosEmpresaEmLote'
import alterarUsuario from '../../../actions/usuario/alterarUsuario'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import limparPerfis from '../../../actions/perfil/limparPerfis';
import {
    renderFieldNumerosPorcentagem,
    renderTextArea2,
    required,
    tamanhoPorcentagem,
} from '../../../util/inputs';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import { buscarPerfis } from '../../../actions/usuario/buscarUsuarios';
import { showSuccessMsg } from '../../../util/messagesUtil';
import { getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN } from '../../../security/securityContext';
import Titulo from '../../comum/Titulo';
import Autorizacao from '../../../security/Autorizacao';
import validator from 'validator'

const OPCAO_DESCONTO_MEIA_PASSAGEM = [
    { label: 'Aplicar desconto no valor da Empresa', value: 'EMPRESA' },
    { label: 'Aplicar desconto no valor da ANTT', value: 'ANTT' },
    { label: 'Aplicar desconto no valor da ANTT e Empresa', value: 'ANTT_EMPRESA' },
];

const PERFIS_VENDEDOR = ['ROLE_VENDEDOR_AGENCIA', 'ROLE_VENDEDOR_EMPRESA', 'ROLE_OPERADOR_REMARCACAO', 'ROLE_ADMIN_EMPRESA'];

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

const SELECT_STYLES = {
    control: base => ({ ...base, fontSize: 13, minHeight: 36, borderColor: '#e4e7ea' }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    multiValue: base => ({ ...base, background: 'rgba(255,106,0,0.10)', borderRadius: 4 }),
    multiValueLabel: base => ({ ...base, color: '#c94400', fontWeight: 600 }),
    multiValueRemove: base => ({ ...base, color: '#c94400' }),
};

export class ModalCadastrarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.state = {
            usuario: '',
            perfisSelecionados: [],
            perfis: [],
            emails: [],
        };
    }

    componentDidMount() {
        this.props.limparRetornocadastramentoUsuariosEmpresaEmLote();
        this.props.buscarPerfis().then(resp => this.setState({ perfis: resp.payload.data }));
        this.limparFormulario();
    }

    ehVendedor() {
        return this.state.perfisSelecionados.some(f => PERFIS_VENDEDOR.includes(f.value));
    }

    exibirComboOpcaoDescontoMeiaPassagem(event) {
        if (!this.props.opcaoDescontoMeiaPassagem) {
            this.props.changeFieldValue('formularioCadastroUsuarioEmLote',
                'opcaoDescontoMeiaPassagem', { label: 'Aplicar desconto no valor da ANTT', value: 'ANTT' });
        }
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                    placeholder='Selecione uma opção de desconto'
                    options={OPCAO_DESCONTO_MEIA_PASSAGEM}
                    styles={SELECT_STYLES}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onChange={value => event.input.onChange(value)}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched && event.meta.error && <span style={{ color: 'red', fontSize: 11 }}>{event.meta.error}</span>}
            </div>
        );
    }

    exibirComboPerfil() {
        return (
            <Select
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                value={this.state.perfisSelecionados}
                isMulti
                placeholder='Selecione um ou mais perfis...'
                options={this.state.perfis}
                styles={SELECT_STYLES}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={event => this.setState({ perfisSelecionados: [...event] })}
            />
        );
    }

    exibirComissao() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Comissão (%)</label>
                        <input type="text" className="form-control" readOnly value='08.38' name='comissao' />
                    </div>
                );
            }
            return (
                <Field name='comissao' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="Comissão (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuarioEmLote', 'comissao', '');
        return null;
    }

    exibirComissaoEncomenda() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>C. Encomenda (%)</label>
                        <input type="text" className="form-control" readOnly value='10.00' name='comissaoEncomenda' />
                    </div>
                );
            }
            return (
                <Field name='comissaoEncomenda' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C. Encomenda (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuario', 'comissaoEncomenda', '00.00');
        return null;
    }

    exibirComissaoExcessoBagagem() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>C. Exc. Bagagem (%)</label>
                        <input type="text" className="form-control" readOnly value='10.00' name='comissaoExcessoBagagem' />
                    </div>
                );
            }
            return (
                <Field name='comissaoExcessoBagagem' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C. Exc. Bagagem (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuario', 'comissaoExcessoBagagem', '00.00');
        return null;
    }

    exibirComissaoImpressaoBilhete() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>C. Impressão Bilhete (%)</label>
                        <input type="text" className="form-control" readOnly value='10.00' name='comissaoImpressaoBilhete' />
                    </div>
                );
            }
            return (
                <Field name='comissaoImpressaoBilhete' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C. Impressão Bilhete (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuario', 'comissaoImpressaoBilhete', '00.00');
        return null;
    }

    exibirComissaoEntrega() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>C. Entrega (%)</label>
                        <input type="text" className="form-control" readOnly value='10.00' name='comissaoEntrega' />
                    </div>
                );
            }
            return (
                <Field name='comissaoEntrega' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C. Entrega (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuario', 'comissaoEntrega', '00.00');
        return null;
    }

    exibirComissaoSeguro() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>C. Seguro (%)</label>
                        <input type="text" className="form-control" readOnly value='10.00' name='comissaoSeguro' />
                    </div>
                );
            }
            return (
                <Field name='comissaoSeguro' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C. Seguro (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuario', 'comissaoSeguro', '00.00');
        return null;
    }

    exibirImpostoRetidoUsuaio() {
        if (this.ehVendedor()) {
            if (this.props.empresaSelecionada.grupo === 'TCB' ||
                this.props.empresaSelecionada.grupo === 'BUSER' ||
                this.props.empresaSelecionada.grupo === 'CIDAO') {
                return (
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Imposto Retido (%)</label>
                        <input type="text" className="form-control" readOnly value='16.25' name='impostoRetido' />
                    </div>
                );
            }
            return (
                <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="Imposto Retido (%)" />
            );
        }
        this.props.changeFieldValue('formularioCadastroUsuarioEmLote', 'impostoRetido', '');
        return null;
    }

    adicionarPerfil(perfil) {
        const perfis = Object.assign([], this.state.perfisSelecionados);
        if (!perfis.find(f => f.value === perfil.value)) {
            perfis.push(perfil);
            this.props.selecionarPerfis(perfis);
        }
    }

    montarParametroUsuario(values) {
        const comissoes = [
            { tipoServico: 'RESERVA', porcentagem: values.comissao },
            { tipoServico: 'ENCOMENDA', porcentagem: values.comissaoEncomenda },
            { tipoServico: 'EXCESSO_BAGAGEM', porcentagem: values.comissaoExcessoBagagem },
            { tipoServico: 'IMPRESSAO_BILHETE', porcentagem: values.comissaoImpressaoBilhete },
            { tipoServico: 'ENTREGA_ENCOMENDA', porcentagem: values.comissaoEntrega },
            { tipoServico: 'SEGURO', porcentagem: values.comissaoSeguro },
        ].filter(c => c.porcentagem !== undefined && c.porcentagem !== null && c.porcentagem !== ''); // remove comissões não preenchidas (perfil sem exigência de comissão)
        return {
            empresaId: this.props.empresaSelecionada.id,
            emails: this.state.emails,
            roles: this.state.perfisSelecionados.map(perfil => perfil.value),
            comissoes,
            impostoRetido: values.impostoRetido,
            venderValorANTT: values.venderValorANTT,
            tipoDescontoMeiaPassagem: values.opcaoDescontoMeiaPassagem ? values.opcaoDescontoMeiaPassagem.value : 'EMPRESA',
        };
    }

    submit(values) {
        this.props.cadastrarUsuariosEmpresaEmLote(this.montarParametroUsuario(values))
            .then(() => {
                showSuccessMsg('Usuários cadastrados com sucesso');
                this.limparFormulario();
            });
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuarioEmLote');
        this.setState({ perfisSelecionados: [], emails: [] });
        this.props.limparPerfis();
    }

    fechar() {
        this.setState({ paginaAtual: 1 });
        this.limparFormulario();
        this.props.limparPerfis();
    }

    adicionarEmails(event) {
        event.preventDefault();
        const map = this.props.emails.replace(/\s/g, '').split(',');
        this.setState({ emails: map.filter(j => validator.isEmail(j)) });
        this.props.changeFieldValue('formularioCadastroUsuarioEmLote', 'emails', '');
    }

    removerEmail(email) {
        this.setState({ emails: this.state.emails.filter(it => it !== email) });
    }

    exibirCadastramento() {
        const { handleSubmit, submitting, invalid } = this.props;
        const ehVendedor = this.ehVendedor();
        const podeSalvar = !invalid && !submitting && this.state.emails.length > 0 && this.state.perfisSelecionados.length > 0;

        return (
            <form onSubmit={handleSubmit(this.submit)} className="vx-config-page">

                {/* ── Perfil e Permissões ── */}
                <SectionCard icon="supervisor_account" title="Perfil e Permissões" subtitle="Selecione os perfis e configure as comissões dos usuários">

                    <div style={{ marginBottom: 16 }}>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>
                            Perfil do Usuário: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Field id='perfil' name='perfil'
                            component={() => this.exibirComboPerfil()} />
                    </div>

                    {ehVendedor && (
                        <>
                            <div className="vx-toggle-row">
                                <div className="vx-toggle-info">
                                    <div className="vx-toggle-info-title">Vender com Valor ANTT</div>
                                    <div className="vx-toggle-info-desc">Habilita o usuário a vender passagens pelo valor tabelado da ANTT</div>
                                </div>
                                <Field name='venderValorANTT' type="checkbox" component={renderToggle} />
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 14, marginTop: 16 }}>
                                {this.exibirComissao()}
                                {this.exibirComissaoEncomenda()}
                                {this.exibirComissaoExcessoBagagem()}
                                {this.exibirComissaoImpressaoBilhete()}
                                {this.exibirComissaoEntrega()}
                                {this.exibirComissaoSeguro()}
                            </div>

                            <div style={{ maxWidth: 220, marginTop: 14 }}>
                                {this.exibirImpostoRetidoUsuaio()}
                            </div>

                            <div style={{ marginTop: 14 }}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>
                                    Opção de Desconto — Meia Passagem:
                                </label>
                                <div style={{ maxWidth: 420 }}>
                                    <Field name='opcaoDescontoMeiaPassagem'
                                        component={this.exibirComboOpcaoDescontoMeiaPassagem.bind(this)} />
                                </div>
                            </div>
                        </>
                    )}
                </SectionCard>

                {/* ── E-mails dos Usuários ── */}
                <SectionCard icon="email" title="E-mails dos Usuários" subtitle="Informe os e-mails separados por vírgula e clique em Adicionar">
                    <div className="vx-add-row vx-add-row-1" style={{ marginBottom: 12 }}>
                        <Field name="emails" type="email" component={renderTextArea2}
                            label="E-mails (separados por vírgula):"
                            css="form-control" readOnly={false} />
                        <button className="vx-btn-incluir" type="button"
                            disabled={!this.props.emails}
                            onClick={(event) => this.adicionarEmails(event)}>
                            <i className="material-icons" style={{ fontSize: 14 }}>add</i> Adicionar
                        </button>
                    </div>

                    <div className="vx-item-list">
                        {this.state.emails.length === 0 ? (
                            <div className="vx-item-list-empty">Nenhum e-mail adicionado</div>
                        ) : (
                            this.state.emails.map((email, index) => (
                                <div key={email} className="vx-item-list-item">
                                    <div className="vx-item-list-item-info">
                                        <span style={{ fontSize: 11, color: '#aaa', marginRight: 8, fontWeight: 600 }}>#{index + 1}</span>
                                        <i className="material-icons" style={{ fontSize: 14, color: 'var(--vx-primary)', marginRight: 6 }}>email</i>
                                        <span className="vx-item-list-item-label">{email}</span>
                                    </div>
                                    <button type="button" className="vx-item-list-remove"
                                        onClick={() => this.removerEmail(email)}>
                                        <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                                    </button>
                                </div>
                            ))
                        )}
                    </div>
                </SectionCard>

                {/* ── Save bar ── */}
                <div className="vx-config-save-bar">
                    <span className="vx-config-save-hint">
                        <i className="material-icons">info_outline</i>
                        {this.state.perfisSelecionados.length === 0
                            ? 'Selecione ao menos um perfil'
                            : this.state.emails.length === 0
                                ? 'Adicione ao menos um e-mail'
                                : `${this.state.emails.length} e-mail(s) · ${this.state.perfisSelecionados.length} perfil(s) selecionado(s)`
                        }
                    </span>
                    <button id="btn-salvar" type="submit"
                        disabled={!podeSalvar}
                        className="btn btn-laranja vx-config-save-btn">
                        <i className="material-icons">group_add</i>
                        Cadastrar Usuários
                    </button>
                </div>
            </form>
        );
    }

    exibirRetornoProcessamento() {
        return (
            <div>
                <div className="vx-table-card" style={{ marginBottom: 16 }}>
                    <div className="vx-table-scroll">
                        <table className="vx-table-left">
                            <thead>
                                <tr>
                                    <th>E-mail</th>
                                    <th>Situação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.retornoCadatramentoEmLote.map((retorno, index) => (
                                    <tr key={`retorno-${index}`}>
                                        <td>{retorno.email}</td>
                                        <td>
                                            <span style={{
                                                padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700,
                                                background: retorno.situacao === 'SUCESSO' ? 'rgba(40,167,69,0.12)' : 'rgba(220,53,69,0.10)',
                                                color: retorno.situacao === 'SUCESSO' ? '#1e7e34' : '#c62828',
                                            }}>
                                                {retorno.situacao}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <button className="vx-toolbar-btn vx-toolbar-btn--secondary" type="button"
                    onClick={() => {
                        this.limparFormulario();
                        this.props.limparRetornocadastramentoUsuariosEmpresaEmLote();
                    }}>
                    <i className="material-icons" style={{ fontSize: 16 }}>arrow_back</i>
                    Voltar ao Cadastro
                </button>
            </div>
        );
    }

    render() {
        return (
            <div className="container-padrao">
                <Titulo texto="Cadastro de Usuários em Lote" urlRetorno="/painel-usuarios" />
                <Autorizacao perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                ]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    {this.props.retornoCadatramentoEmLote
                        ? this.exibirRetornoProcessamento()
                        : this.exibirCadastramento()
                    }
                </Autorizacao>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        opcaoDescontoMeiaPassagem: formValueSelector('formularioCadastroUsuarioEmLote')(state, 'opcaoDescontoMeiaPassagem'),
        emails: formValueSelector('formularioCadastroUsuarioEmLote')(state, 'emails'),
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        retornoCadatramentoEmLote: state.usuariosEmpresa.retornoCadatramentoEmLote,
    };
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuariosEmpresaEmLote,
        selecionarPerfis,
        buscarUsuarioPorEmail,
        alterarUsuario,
        limparPerfis,
        buscarPerfis,
        limparRetornocadastramentoUsuariosEmpresaEmLote,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroUsuarioEmLote',
})(ModalCadastrarUsuario));
